<template>
  <no-auth v-if="!hasAuthorize.calculate"></no-auth>
  <div class="container-fluid o-card" v-else>
    <h4>
      {{ $t("navigation.ehouseCalculating") }}
    </h4>
    <hr />
    <div class="row">
      <div class="es-xs-12 es-sm-3">
        <div class="u-margin-bottom-small">
          <h6 class="u-margin-bottom-xsmall">
            {{ $t("ehouseCalculating.inletData") }}
          </h6>
          <BaseInput
            v-model="form.locationFactor"
            :label="$t('ehouseCalculating.locationFactor')"
            block
            class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
            :size="creatingPdf ? 'sm' : 'xs'"
            step="0.0001"
            suffix="m"
            type="number"
            :placeholder="$t('ehouseCalculating.locationFactor')"
            mandotary
          ></BaseInput>
          <BaseInput
            v-model="form.atmosphericPressure"
            :label="$t('ehouseCalculating.atmosphericPressure')"
            block
            step="0.0001"
            suffix="kPa"
            class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
            :size="creatingPdf ? 'sm' : 'xs'"
            type="number"
            :placeholder="$t('ehouseCalculating.atmosphericPressure')"
            mandotary
          ></BaseInput>
          <BaseInput
            v-model="form.ambientTemperature"
            :label="$t('ehouseCalculating.ambientTemperature')"
            block
            step="0.0001"
            suffix="°C"
            class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
            :size="creatingPdf ? 'sm' : 'xs'"
            type="number"
            :placeholder="$t('ehouseCalculating.ambientTemperature')"
            mandotary
          ></BaseInput>
          <BaseInput
            v-model="form.ambientHumidity"
            :label="$t('ehouseCalculating.ambientHumidity')"
            block
            step="0.0001"
            suffix="%"
            class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
            :size="creatingPdf ? 'sm' : 'xs'"
            type="number"
            :placeholder="$t('ehouseCalculating.ambientHumidity')"
            mandotary
          ></BaseInput>
          <BaseInput
            v-model="form.radiationPower"
            :label="$t('ehouseCalculating.radiationPower')"
            block
            step="0.0001"
            suffix="W/m²"
            class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
            :size="creatingPdf ? 'sm' : 'xs'"
            type="number"
            :placeholder="$t('ehouseCalculating.radiationPower')"
            mandotary
          ></BaseInput>
        </div>
        <div class="u-margin-bottom-small">
          <h6 class="u-margin-bottom-xsmall">
            {{ $t("ehouseCalculating.geometricParameters") }}
          </h6>
          <BaseInput
            v-model="form.length"
            :label="$t('ehouseCalculating.length')"
            block
            class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
            :size="creatingPdf ? 'sm' : 'xs'"
            type="number"
            step="0.0001"
            suffix="mm"
            :placeholder="$t('ehouseCalculating.length')"
            mandotary
          ></BaseInput>
          <BaseInput
            v-model="form.width"
            :label="$t('ehouseCalculating.width')"
            block
            step="0.0001"
            suffix="mm"
            class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
            :size="creatingPdf ? 'sm' : 'xs'"
            type="number"
            :placeholder="$t('ehouseCalculating.width')"
            mandotary
          ></BaseInput>
          <BaseInput
            v-model="form.height"
            :label="$t('ehouseCalculating.height')"
            block
            step="0.0001"
            suffix="mm"
            class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
            :size="creatingPdf ? 'sm' : 'xs'"
            type="number"
            :placeholder="$t('ehouseCalculating.height')"
            mandotary
          ></BaseInput>
          <BaseInput
            v-model="form.numberOfDoors"
            :label="$t('ehouseCalculating.numberOfDoors')"
            block
            :step="0.0001"
            :suffix="$t('common.pcs')"
            class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
            :size="creatingPdf ? 'sm' : 'xs'"
            type="number"
            :placeholder="$t('ehouseCalculating.numberOfDoors')"
            mandotary
          ></BaseInput>
          <BaseInput
            v-model="form.electricalInletOutlet"
            :label="$t('ehouseCalculating.electricalInletOutlet')"
            block
            step="0.0001"
            :suffix="$t('common.pcs')"
            class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
            :size="creatingPdf ? 'sm' : 'xs'"
            type="number"
            :placeholder="$t('ehouseCalculating.electricalInletOutlet')"
            mandotary
          ></BaseInput>
        </div>
        <div class="u-margin-bottom-small">
          <h6 class="u-margin-bottom-xsmall">
            {{ $t("ehouseCalculating.mainRoomAirConditions") }}
          </h6>
          <BaseInput
            v-model="form.airTemperature"
            :label="$t('ehouseCalculating.airTemperature')"
            block
            :step="0.0001"
            suffix="°C"
            class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
            :size="creatingPdf ? 'sm' : 'xs'"
            type="number"
            :placeholder="$t('ehouseCalculating.airTemperature')"
            mandotary
          ></BaseInput>
          <BaseInput
            v-model="form.relativeHumidity"
            :label="$t('ehouseCalculating.relativeHumidity')"
            block
            step="0.0001"
            suffix="%"
            class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
            :size="creatingPdf ? 'sm' : 'xs'"
            type="number"
            :placeholder="$t('ehouseCalculating.relativeHumidity')"
            mandotary
          ></BaseInput>
          <BaseInput
            v-model="form.heatGeneration"
            :label="$t('ehouseCalculating.heatGeneration')"
            block
            step="0.0001"
            suffix="kW"
            class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
            :size="creatingPdf ? 'sm' : 'xs'"
            type="number"
            :placeholder="$t('ehouseCalculating.heatGeneration')"
            mandotary
          ></BaseInput>
          <BaseInput
            v-model="form.requiredPressurization"
            :label="$t('ehouseCalculating.requiredPressurization')"
            block
            step="0.0001"
            suffix="Pa"
            class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
            :size="creatingPdf ? 'sm' : 'xs'"
            type="number"
            :placeholder="$t('ehouseCalculating.requiredPressurization')"
            mandotary
          ></BaseInput>
          <BaseInput
            v-model="form.requiredPressurizationStandard"
            :label="$t('ehouseCalculating.requiredPressurizationStandard')"
            block
            readonly
            step="0.0001"
            suffix="Pa"
            class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
            :size="creatingPdf ? 'sm' : 'xs'"
            type="number"
            :placeholder="
              $t('ehouseCalculating.requiredPressurizationStandard')
            "
            mandotary
          ></BaseInput>
        </div>
      </div>
      <div class="es-xs-12 es-sm-5">
        <h6 class="u-margin-bottom-xsmall">
          {{ $t("ehouseCalculating.wallsConstructionDetails") }}
        </h6>
        <div class="row">
          <div class="es-xs-6">
            <p>
              <small>
                {{ $t("ehouseCalculating.innerSideHeatConvectionCoefficient") }}
              </small>
            </p>
          </div>
          <div class="es-xs-3">
            <BaseInput
              :value="0"
              readonly
              disabled
              class="u-margin-0"
              block
              size="xs"
              step="0.0001"
              suffix="mm"
            ></BaseInput>
          </div>
          <div class="es-xs-3">
            <BaseInput
              :value="8"
              readonly
              disabled
              class="u-margin-0"
              block
              size="xs"
              step="0.0001"
              suffix="W/m.K"
            ></BaseInput>
          </div>
        </div>
        <div class="row">
          <div class="es-xs-6">
            <GetMetallicMaterials
              class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-0 u-flex-1-with-child c-form-control__variant--xs"
              v-model="form.steelPlateThermalConductivity"
              :label="$t('ehouseDoubleCalculating.wallMaterialValues1')"
            ></GetMetallicMaterials>
          </div>
          <div class="es-xs-3">
            <BaseInput
              v-model="form.steelPlateThickness"
              class="u-margin-0"
              block
              size="xs"
              step="0.0001"
              suffix="mm"
            ></BaseInput>
          </div>
          <div class="es-xs-3">
            <BaseInput
              :value="form.steelPlateThermalConductivity.value"
              readonly
              disabled
              class="u-margin-0"
              block
              size="xs"
              step="0.0001"
              suffix="W/m.K"
            ></BaseInput>
          </div>
        </div>
        <div class="row">
          <div class="es-xs-6">
            <GetInsulationMaterials
              v-model="form.asbestosThermalConductivity"
              class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-0 u-flex-1-with-child c-form-control__variant--xs"
              :label="$t('ehouseDoubleCalculating.wallMaterialValues2')"
            ></GetInsulationMaterials>
          </div>
          <div class="es-xs-3">
            <BaseInput
              v-model="form.asbestosThickness"
              class="u-margin-0"
              block
              size="xs"
              step="0.0001"
              suffix="mm"
            ></BaseInput>
          </div>
          <div class="es-xs-3">
            <BaseInput
              :value="form.asbestosThermalConductivity.value"
              readonly
              class="u-margin-0"
              block
              size="xs"
              step="0.0001"
              suffix="W/m.K"
            ></BaseInput>
          </div>
        </div>
        <div class="row">
          <div class="es-xs-6">
            <GetBuildingMaterials
              class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-0 u-flex-1-with-child c-form-control__variant--xs"
              v-model="form.noneMaterialThermalConductivity"
              :label="$t('ehouseDoubleCalculating.wallMaterialValues3')"
            ></GetBuildingMaterials>
          </div>
          <div class="es-xs-3">
            <BaseInput
              v-model="form.noneMaterialThickness"
              class="u-margin-0"
              block
              size="xs"
              step="0.0001"
              suffix="mm"
            ></BaseInput>
          </div>
          <div class="es-xs-3">
            <BaseInput
              :value="form.noneMaterialThermalConductivity.value"
              readonly
              disabled
              class="u-margin-0"
              block
              size="xs"
              step="0.0001"
              suffix="W/m.K"
            ></BaseInput>
          </div>
        </div>
        <div class="row u-align-items-flex-end">
          <div class="es-xs-6">
            <GetBuildingMaterials
              class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-0 u-flex-1-with-child c-form-control__variant--xs"
              v-model="form.pvcThermalConductivity"
              :label="$t('ehouseDoubleCalculating.wallMaterialValues4')"
            ></GetBuildingMaterials>
          </div>
          <div class="es-xs-3">
            <BaseInput
              v-model="form.pvcThickness"
              class="u-margin-0"
              block
              size="xs"
              step="0.0001"
              suffix="mm"
            ></BaseInput>
          </div>
          <div class="es-xs-3">
            <BaseInput
              :value="form.pvcThermalConductivity.value"
              readonly
              disabled
              class="u-margin-0"
              block
              size="xs"
              step="0.0001"
              suffix="W/m.K"
            ></BaseInput>
          </div>
        </div>
        <div class="row">
          <div class="es-xs-6">
            <p>
              <small>
                {{ $t("ehouseCalculating.outerSideHeatConvectionCoefficient") }}
              </small>
            </p>
          </div>
          <div class="es-xs-3">
            <BaseInput
              :value="0"
              readonly
              disabled
              class="u-margin-0"
              block
              size="xs"
              step="0.0001"
              suffix="mm"
            ></BaseInput>
          </div>
          <div class="es-xs-3">
            <BaseInput
              :value="23"
              readonly
              disabled
              class="u-margin-0"
              block
              size="xs"
              step="0.0001"
              suffix="W/m.K"
            ></BaseInput>
          </div>
        </div>

        <Button
          block
          variant="warning"
          @click="calculate"
          class="u-margin-top-small u-margin-bottom-small"
        >
          {{ $t("ehouseCalculating.calculate") }}
        </Button>
        <div class="u-margin-bottom">
          <img
            src="@/assets/images/ehouse-sema.png"
            width="100%"
            alt="ehouse sema"
          />
        </div>
      </div>
      <div class="es-xs-12 es-sm-4" v-if="result.status" id="result">
        <div class="u-background-color-white o-card__padding-small">
          <h6 class="u-margin-bottom-xsmall">
            {{ $t("ehouseCalculating.result") }}
          </h6>
          <div>
            <BaseInput
              v-model="result.wallsCeilingFloorHeatTransfer"
              :label="$t('ehouseCalculating.wallsCeilingFloorHeatTransfer')"
              class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
              block
              readonly
              disabled
              step="0.0001"
              suffix="W/m².K"
              size="xs"
            ></BaseInput>
          </div>
          <div>
            <BaseInput
              v-model="result.heatTransmission"
              :label="$t('ehouseCalculating.heatTransmission')"
              class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
              block
              readonly
              disabled
              step="0.0001"
              suffix="kW"
              size="xs"
            ></BaseInput>
          </div>
          <div>
            <BaseInput
              v-model="result.heatRadiation"
              :label="$t('ehouseCalculating.heatRadiation')"
              class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
              block
              readonly
              disabled
              step="0.0001"
              suffix="kW"
              size="xs"
            >
            </BaseInput>
          </div>
          <div>
            <BaseInput
              v-model="result.heatDevices"
              class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
              block
              readonly
              disabled
              size="xs"
              :label="$t('ehouseCalculating.heatDevices')"
              step="0.0001"
              suffix="kW"
            ></BaseInput>
          </div>
          <div>
            <BaseInput
              v-model="result.freshAirHeatGain"
              :label="$t('ehouseCalculating.freshAirHeatGain')"
              block
              class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
              readonly
              disabled
              step="0.0001"
              suffix="kW"
              size="xs"
            >
            </BaseInput>
          </div>
          <div>
            <BaseInput
              v-model="result.airFlow"
              class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
              block
              readonly
              disabled
              size="xs"
              :label="$t('ehouseCalculating.airFlow')"
              step="0.0001"
              suffix="m³/h"
            ></BaseInput>
          </div>
          <BaseInput
            v-model="result.airFlowInfiltration"
            class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
            :label="$t('ehouseCalculating.airFlowInfiltration')"
            block
            readonly
            disabled
            size="xs"
            suffix="m³/h"
          ></BaseInput>

          <div>
            <BaseInput
              v-model="result.condensateWater"
              class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
              :label="$t('ehouseCalculating.condensateWater')"
              block
              readonly
              disabled
              step="0.0001"
              suffix="kg/h"
              size="xs"
            ></BaseInput>
          </div>
          <div>
            <BaseInput
              v-model="result.heatCalculated"
              class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
              :label="$t('ehouseCalculating.heatCalculated')"
              block
              readonly
              disabled
              step="0.0001"
              suffix="kW"
              size="xs"
            ></BaseInput>
          </div>
          <div>
            <BaseInput
              v-model="result.totalHeatGain"
              class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
              :label="$t('ehouseCalculating.totalHeatGain')"
              block
              readonly
              disabled
              suffix="kW"
              size="xs"
            >
            </BaseInput>
          </div>
          <BaseInput
            class="u-margin-top-small"
            :label="$t('vincCalculating.title')"
            v-model="title"
            v-if="hasAuthorize.add"
            block
            disabled
            size="sm"
          ></BaseInput>
          <div class="u-display-flex">
            <Button
              block
              :disabled="!title"
              v-if="hasAuthorize.add"
              variant="primary"
              class="u-margin-top"
              @click="save"
            >
              {{ $t("common.save") }}
            </Button>
            <Button
              block
              variant="danger "
              class="u-margin-top"
              @click="creatingPdf = true"
            >
              {{ $t("common.printCalculation") }}
            </Button>
          </div>
          <div>
            <router-link v-if="!creatingPdf" :to="{ name: 'cycles-selection' }">
              <Button block variant="primary" class="u-margin-top">
                {{ $t("cycles.selection2") }}
              </Button>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <Detail
      v-if="creatingPdf"
      :title="title"
      :form="form"
      :result="result"
      auto-print
      @pdfCreated="creatingPdf = false"
    ></Detail>
  </div>
</template>

<script>
import BaseInput from "@/components/Base/Inputs/BaseInput.vue";
import Button from "@/components/Base/Button.vue";
import Requests from "@/services/Requests";
import Detail from "./Detail.vue";
import GetBuildingMaterials from "./Searches/GetBuildingMaterials.vue";
import GetInsulationMaterials from "./Searches/GetInsulationMaterials.vue";
import GetMetallicMaterials from "./Searches/GetMetallicMaterials.vue";
import authorize from "./authorize";
export default {
  mixins: [authorize],
  components: {
    BaseInput,
    Button,
    Detail,
    GetBuildingMaterials,
    GetInsulationMaterials,
    GetMetallicMaterials,
  },
  data() {
    return {
      title: "",
      creatingPdf: false,
      form: {
        pvcThickness: 0,
        noneMaterialThickness: 0,
        steelPlateThickness: 2,
        asbestosThickness: 80,
        airTemperature: 27.0001,
        relativeHumidity: 50,
        heatGeneration: 40,
        requiredPressurization: 20,
        requiredPressurizationStandard: 4,
        locationFactor: 250,
        atmosphericPressure: 100,
        ambientTemperature: 35,
        ambientHumidity: 40,
        radiationPower: 646,
        length: 15000,
        width: 11500,
        height: 3000,
        numberOfDoors: 1,
        electricalInletOutlet: 1,
        pvcThermalConductivity: {
          key: "PVC",
          value: 0.23,
        },
        noneMaterialThermalConductivity: {
          key: "None",
          value: 1,
        },
        steelPlateThermalConductivity: {
          key: "Steel Plate",
          value: 54,
        },
        asbestosThermalConductivity: {
          key: "Asbest",
          value: 0.154,
        },
      },
      result: {
        status: false,
        wallsCeilingFloorHeatTransfer: 1.453,
        heatTransmission: 10.98,
        heatRadiation: 7.04,
        heatDevices: 40,
        freshAirHeatGain: 0.22,
        airFlow: 24984.038,
        airFlowInfiltration: 29.83,
        condensateWater: 0.11,
        heatCalculated: 58.24,
        totalHeatGain: 64.07,
        additionalHumidityRequired: 27.01,
        safetyFactor: 10,
      },
    };
  },
  methods: {
    VALIDATION_ERROR_MESSAGE(message) {
      this.$store.dispatch("SET_ACTION_MODAL", {
        isLoading: false,
        status: true,
        message: message,
        variant: "danger",
        duration: 2500,
      });
      return true;
    },
    validation() {
      if (!this.form.locationFactor)
        return this.VALIDATION_ERROR_MESSAGE(
          this.$t("message.required.description", {
            field: this.$t("ehouseCalculating.locationFactor"),
          })
        );
      else if (!this.form.atmosphericPressure)
        return this.VALIDATION_ERROR_MESSAGE(
          this.$t("message.required.description", {
            field: this.$t("ehouseCalculating.atmosphericPressure"),
          })
        );
      else if (!this.form.ambientTemperature)
        return this.VALIDATION_ERROR_MESSAGE(
          this.$t("message.required.description", {
            field: this.$t("ehouseCalculating.ambientTemperature"),
          })
        );
      else if (!this.form.ambientHumidity)
        return this.VALIDATION_ERROR_MESSAGE(
          this.$t("message.required.description", {
            field: this.$t("ehouseCalculating.ambientHumidity"),
          })
        );
      else if (!this.form.radiationPower)
        return this.VALIDATION_ERROR_MESSAGE(
          this.$t("message.required.description", {
            field: this.$t("ehouseCalculating.radiationPower"),
          })
        );
      else if (!this.form.length)
        return this.VALIDATION_ERROR_MESSAGE(
          this.$t("message.required.description", {
            field: this.$t("ehouseCalculating.length"),
          })
        );
      else if (!this.form.width)
        return this.VALIDATION_ERROR_MESSAGE(
          this.$t("message.required.description", {
            field: this.$t("ehouseCalculating.width"),
          })
        );
      else if (!this.form.height)
        return this.VALIDATION_ERROR_MESSAGE(
          this.$t("message.required.description", {
            field: this.$t("ehouseCalculating.height"),
          })
        );
      else if (!this.form.numberOfDoors)
        return this.VALIDATION_ERROR_MESSAGE(
          this.$t("message.required.description", {
            field: this.$t("ehouseCalculating.numberOfDoors"),
          })
        );
      else if (!this.form.electricalInletOutlet)
        return this.VALIDATION_ERROR_MESSAGE(
          this.$t("message.required.description", {
            field: this.$t("ehouseCalculating.electricalInletOutlet"),
          })
        );
      else if (!this.form.airTemperature)
        return this.VALIDATION_ERROR_MESSAGE(
          this.$t("message.required.description", {
            field: this.$t("ehouseCalculating.airTemperature"),
          })
        );
      else if (!this.form.relativeHumidity)
        return this.VALIDATION_ERROR_MESSAGE(
          this.$t("message.required.description", {
            field: this.$t("ehouseCalculating.relativeHumidity"),
          })
        );
      else if (!this.form.heatGeneration)
        return this.VALIDATION_ERROR_MESSAGE(
          this.$t("message.required.description", {
            field: this.$t("ehouseCalculating.heatGeneration"),
          })
        );
      else if (!this.form.requiredPressurization)
        return this.VALIDATION_ERROR_MESSAGE(
          this.$t("message.required.description", {
            field: this.$t("ehouseCalculating.requiredPressurization"),
          })
        );
      else if (!this.form.requiredPressurizationStandard)
        return this.VALIDATION_ERROR_MESSAGE(
          this.$t("message.required.description", {
            field: this.$t("ehouseCalculating.requiredPressurizationStandard"),
          })
        );
      else if (!this.form.pvcThickness && this.form.pvcThickness !== 0)
        return this.VALIDATION_ERROR_MESSAGE(
          this.$t("message.required.description", {
            field: this.$t("ehouseCalculating.pvcThickness"),
          })
        );
      else if (
        !this.form.noneMaterialThickness &&
        this.form.noneMaterialThickness !== 0
      )
        return this.VALIDATION_ERROR_MESSAGE(
          this.$t("message.required.description", {
            field: this.$t("ehouseCalculating.noneMaterialThickness"),
          })
        );
      else if (
        !this.form.steelPlateThickness &&
        this.form.steelPlateThickness !== 0
      )
        return this.VALIDATION_ERROR_MESSAGE(
          this.$t("message.required.description", {
            field: this.$t("ehouseCalculating.steelPlateThickness"),
          })
        );
      else if (
        !this.form.asbestosThickness &&
        this.form.asbestosThickness !== 0
      )
        return this.VALIDATION_ERROR_MESSAGE(
          this.$t("message.required.description", {
            field: this.$t("ehouseCalculating.asbestosThickness"),
          })
        );
      return false;
    },
    async calculate(e, loading) {
      const validation = this.validation();
      if (validation) return;
      loading(true);
      const response = await Requests.HeatGain.Calculate({
        pvcThickness: Number(this.form.pvcThickness),
        noneMaterialThickness: Number(this.form.noneMaterialThickness),
        steelPlateThickness: Number(this.form.steelPlateThickness),
        asbestosThickness: Number(this.form.asbestosThickness),
        pvcThermalConductivity: Number(this.form.pvcThermalConductivity.value),
        noneMaterialThermalConductivity: Number(
          this.form.noneMaterialThermalConductivity.value
        ),
        steelPlateThermalConductivity: Number(
          this.form.steelPlateThermalConductivity.value
        ),
        asbestosThermalConductivity: Number(
          this.form.asbestosThermalConductivity.value
        ),
        locationFactor: Number(this.form.locationFactor),
        atmosphericPressure: Number(this.form.atmosphericPressure),
        ambientTemperature: Number(this.form.ambientTemperature),
        ambientHumidity: Number(this.form.ambientHumidity),
        radiationPower: Number(this.form.radiationPower),
        length: Number(this.form.length),
        width: Number(this.form.width),
        height: Number(this.form.height),
        numberOfDoors: Number(this.form.numberOfDoors),
        electricalInletOutlet: Number(this.form.electricalInletOutlet),
        airTemperature: Number(this.form.airTemperature),
        relativeHumidity: Number(this.form.relativeHumidity),
        heatGeneration: Number(this.form.heatGeneration),
        requiredPressurization: Number(this.form.requiredPressurization),
        requiredPressurizationStandard: Number(
          this.form.requiredPressurizationStandard
        ),
      });
      if (response.message === "OK") {
        this.result = { ...response.data, status: true };
        setTimeout(() => {
          document
            .getElementById("result")
            .scrollIntoView({ behavior: "smooth", block: "center" });
        }, 1000);
      } else {
        this.VALIDATION_ERROR_MESSAGE(
          this.$t(`message.${response.message}.description`)
        );
      }
      loading(false);
    },
    async save(e, loading) {
      const validation = this.validation();
      if (validation) return;
      loading(true);
      const response = await Requests.HeatGain.Create({
        pvcThickness: Number(this.form.pvcThickness),
        noneMaterialThickness: Number(this.form.noneMaterialThickness),
        steelPlateThickness: Number(this.form.steelPlateThickness),
        asbestosThickness: Number(this.form.asbestosThickness),
        pvcThermalConductivity: Number(this.form.pvcThermalConductivity.value),
        noneMaterialThermalConductivity: Number(
          this.form.noneMaterialThermalConductivity.value
        ),
        steelPlateThermalConductivity: Number(
          this.form.steelPlateThermalConductivity.value
        ),
        asbestosThermalConductivity: Number(
          this.form.asbestosThermalConductivity.value
        ),
        title: this.title,
        locationFactor: Number(this.form.locationFactor),
        atmosphericPressure: Number(this.form.atmosphericPressure),
        ambientTemperature: Number(this.form.ambientTemperature),
        ambientHumidity: Number(this.form.ambientHumidity),
        radiationPower: Number(this.form.radiationPower),
        length: Number(this.form.length),
        width: Number(this.form.width),
        height: Number(this.form.height),
        numberOfDoors: Number(this.form.numberOfDoors),
        electricalInletOutlet: Number(this.form.electricalInletOutlet),
        airTemperature: Number(this.form.airTemperature),
        relativeHumidity: Number(this.form.relativeHumidity),
        heatGeneration: Number(this.form.heatGeneration),
        requiredPressurization: Number(this.form.requiredPressurization),
        requiredPressurizationStandard: Number(
          this.form.requiredPressurizationStandard
        ),
      });
      if (response.message === "OK") {
        this.result = { status: false };
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t("common.saveSuccess"),
          variant: "success",
          duration: 2500,
        });
        this.$router.push({
          name: "ehouse-calculating-detail",
          params: { id: response.data },
        });
      } else {
        this.VALIDATION_ERROR_MESSAGE(
          this.$t(`message.${response.message}.description`)
        );
      }
      loading(false);
    },
  },
};
</script>

<style></style>
